export const FIELDS = {
  ID: 'id',
  STATUS_NAME: 'statusName',
  RMADATE: 'rmaDate',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  PODATE: 'poDate',
  STATUS_ID: 'statusId',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  CONTACT_ID: 'contactId',
  CONTACT_NAME: 'contactName',
  CONTACT_EMAIL: 'contactEmail',
  DATE_SHIPPED: 'dateShipped',
  ACTION_ID: 'actionId',
  ACTION_NAME: 'actionName',
  TERMS_ID: 'termsId',
  TERMS_NAME: 'termsName',
  SALES_REP_USER_ID: 'salesRepUserId',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  IS_AUTHORIZED: 'isAuthorized',
  SUB_TOTAL: 'subTotal',
  TOTAL_LINE_COST: 'totalLineCost',
  TOTAL_CHARGES_TAXABLE: 'totalChargesTaxable',
  TOTAL_CHARGES_NON_TAXABLE: 'totalChargesNonTaxable',
  TOTAL_CHARGES: 'totalCharges',
  TOTAL_CHARGES_COST: 'totalChargesCost',
  TOTAL: 'total',
  COMMENTS: 'comments',
  SHIP_FROM_ADDRESS_ID: 'shipFromAddressId',
  SHIP_FROM_ADDRESS: 'shipFromAddress',
  SHIP_TO_ADDRESS_ID: 'shipToAddressId',
  SHIP_TO_ADDRESS: 'shipToAddress',
  INTERNAL_COMMENTS: 'internalComments',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  SHIPPING_METHOD_NAME: 'shippingMethodName',
  JOB_ID: 'jobId',
  VENDOR_RMANUMBER: 'vendorRmaNumber',
  ACCOUNT_NO: 'accountNo',
  IS_TAXABLE: 'isTaxable',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  CURRENCY_SYMBOL: 'currencySymbol',
  EXCHANGE_RATE: 'exchangeRate',
  TAX_RATE: 'taxRate',
  TAX: 'tax',
  SUB_TOTAL_CONVERTED: 'subTotalConverted',
  TOTAL_LINE_COST_CONVERTED: 'totalLineCostConverted',
  TOTAL_CHARGES_TAXABLE_CONVERTED: 'totalChargesTaxableConverted',
  TOTAL_CHARGES_NON_TAXABLE_CONVERTED: 'totalChargesNonTaxableConverted',
  TOTAL_CHARGES_CONVERTED: 'totalChargesConverted',
  TOTAL_CHARGES_COST_CONVERTED: 'totalChargesCostConverted',
  TOTAL_CONVERTED: 'totalConverted',
  VENDOR_SENT_SHIPPING_LABEL: 'vendorSentShippingLabel',
  SHIP_ON_VENDOR_ACCOUNT: 'shipOnVendorAccount',
  ALWAYS_SHIP_BY: 'alwaysShipBy',
  SHIPPING_ACCOUNT_NUMBER: 'shippingAccountNumber',
  TRACKING_NUMBER: 'trackingNumber',
  AUTHORIZED_BY_USER_ID: 'authorizedByUserId',
  AUTHORIZED_BY_USER_FULL_NAME: 'authorizedByUserFullName',
  DATE_AUTHORIZED: 'dateAuthorized',
  DATE_CREATED: 'dateCreated',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER: 'createdByUser',
  DATE_MODIFIED: 'dateModified',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER: 'modifiedByUser',
  ACTIVE: 'active',};